const FAVICON_COLOR_BACKGROUND = '#EB002B';
const FAVICON_COLOR_FOREGROUND = '#FFFFFF';

class Favicon {
  _getDataURLForNumber(num: number) {
    const canvas: HTMLCanvasElement = document.createElement('canvas');

    canvas.width = 32;
    canvas.height = 32;

    const context: CanvasRenderingContext2D | undefined | null = canvas.getContext('2d');

    if (!context) {
      throw new Error('null context from canvas');
    }

    context.fillStyle = FAVICON_COLOR_BACKGROUND;
    this._roundRect(context, 0, 0, 32, 32, 6);

    context.fillStyle = FAVICON_COLOR_FOREGROUND;
    context.textAlign = 'center';
    context.textBaseline = 'top';

    if (num < 99) {
      context.font = 'bold 22px arial';
      context.fillText(String(num), 16, 5);
    } else {
      context.font = 'bold 18px arial';
      context.fillText(String(num), 16, 7);
    }

    return context.canvas.toDataURL();
  }

  _roundRect(
    ctx: CanvasRenderingContext2D,
    x: number,
    y: number,
    width: number,
    height: number,
    radius: number
  ) {
    ctx.beginPath();
    ctx.moveTo(x + radius, y);
    ctx.lineTo(x + width - radius, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
    ctx.lineTo(x + width, y + height - radius);
    ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
    ctx.lineTo(x + radius, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
    ctx.lineTo(x, y + radius);
    ctx.quadraticCurveTo(x, y, x + radius, y);
    ctx.closePath();
    ctx.fill();
  }

  _clearFavicon() {
    // remove existing favicons
    const head = document.getElementsByTagName('head')[0];
    const links = head.getElementsByTagName('link');

    for (let i = links.length - 1; i >= 0; i--) {
      if (links[i].getAttribute('rel') === 'shortcut icon') {
        head.removeChild(links[i]);
      }
    }
  }

  _newFavicon(href: string) {
    const favicon = document.createElement('link');
    favicon.type = 'image/x-icon';
    favicon.rel = 'shortcut icon';
    favicon.href = href;
    return favicon;
  }

  _setFavicon(assetPath: string) {
    this._clearFavicon();
    const favicon = this._newFavicon(assetPath);
    document.getElementsByTagName('head')[0].appendChild(favicon);
  }

  _showDefault() {
    this._setFavicon('/assets/favicon.ico');
  }

  _showAdmin() {
    this._setFavicon('/assets/faviconAC.ico');
  }

  showNumber(num: number) {
    if (window.location.pathname.startsWith('/admin')) {
      this._showAdmin();
    } else {
      if (num > 0) {
        this._setFavicon(this._getDataURLForNumber(num));
      } else {
        this._showDefault();
      }
    }
  }
}

export default new Favicon();
